export const POSTAL_ADDRESS_INVALID_MESSAGE = 'Adresse incorrecte';

const normalizeForObviousInvalidCheck = (value: string) =>
  value
    .trim()
    .replace(/\s+/g, '')
    // iOS / typographie: normaliser EN DASH / EM DASH en '-'
    .replace(/[–—]/g, '-');

export const isInvalidPostalAddress = (value?: string | null): boolean => {
  const v = normalizeForObviousInvalidCheck(value ?? '');
  if (v.length === 0) return false;

  if (/^\d+$/.test(v)) return true;
  if (/^-+$/.test(v)) return true;

  return /^[\d-]+$/.test(v) && /\d/.test(v) && /-/.test(v);
};
